import React, { useState, useEffect } from 'react';
import reiRizz from '../assets/Q10/rei_rizz.jpg';
import yes1 from '../assets/Q10/YES_1_rei_excited_me_question.jpg';
import yes2 from '../assets/Q10/YES_2_rei_excited.jpg';
import yes3 from '../assets/Q10/YES_3_rei_thumbsUp.jpg';
import yes4 from '../assets/Q10/YES_4_rei_happyShines.jpg';
import no1 from '../assets/Q10/NO_1_rei_middleFinger.jpg';
import no2 from '../assets/Q10/NO_2_rei_heavyMood.jpg';
import no3 from '../assets/Q10/NO_3_rei_eyeroll.jpg';
import no4 from '../assets/Q10/NO_4_rei_angry_dots.jpg';
import no5 from '../assets/Q10/NO_5_rei_heavyMoodSmile.jpg';
import hansumGalaxy from '../assets/Q10/hansum_galaxy.jpg';
import hansumShootingStar from '../assets/Q10/hansum_shootingStar.png';
import reiExpectantBlushies from '../assets/Q10/rei_expectant_blushies.jpg';
import hamiltonDanceHappy from '../assets/Q10/hamilton_danceHappy.gif';

const YES_IMGS = [yes1, yes2, yes3, yes4];
const NO_IMGS = [no1, no2, no3, no4, no5];

function Q10({ question = 10, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [yesChecked, setYesChecked] = useState(false);
  const [noChecked, setNoChecked] = useState(false);
  const [cornerImg, setCornerImg] = useState(reiRizz);
  const [yesHoverStep, setYesHoverStep] = useState(0);
  const [noHoverStep, setNoHoverStep] = useState(0);
  const [noSequencePhase, setNoSequencePhase] = useState(null); // null | 'galaxy' | 'rotating' | 'fade' | 'diving' | 'done'
  const [collisionOccurred, setCollisionOccurred] = useState(false);

  const handleYesMouseEnter = () => {
    if (noSequencePhase) return;
    setCornerImg(YES_IMGS[yesHoverStep]);
    setYesHoverStep((prev) => (prev + 1) % YES_IMGS.length);
  };

  const handleNoMouseEnter = () => {
    if (noSequencePhase) return;
    setCornerImg(NO_IMGS[noHoverStep]);
    setNoHoverStep((prev) => (prev + 1) % NO_IMGS.length);
  };

  const handleOptionsMouseLeave = () => {
    if (noSequencePhase || yesChecked) return;
    setCornerImg(null);
  };

  const handleNoClick = () => {
    setNoChecked(true);
    setYesChecked(false);
    setCornerImg(null);
    setCollisionOccurred(false);
    setNoSequencePhase('galaxy'); // show galaxy on left immediately
  };

  const handleYesClick = () => {
    setYesChecked(true);
    setNoChecked(false);
    setNoSequencePhase(null);
    setCollisionOccurred(false);
    setCornerImg(hamiltonDanceHappy);
    setTimeout(() => onNavigate?.('q11'), 2500);
  };

  // Sequence: galaxy (1s) -> rotating (2s) -> 0.5s pause -> fade (0.5s) -> diving (1.5s) -> done
  // Separate effects per phase so cleanup doesn't cancel future timeouts
  useEffect(() => {
    if (noSequencePhase !== 'galaxy') return;
    const t = setTimeout(() => setNoSequencePhase('rotating'), 1000);
    return () => clearTimeout(t);
  }, [noSequencePhase]);

  useEffect(() => {
    if (noSequencePhase !== 'rotating') return;
    const t = setTimeout(() => setNoSequencePhase('fade'), 2000);
    return () => clearTimeout(t);
  }, [noSequencePhase]);

  useEffect(() => {
    if (noSequencePhase !== 'fade') return;
    const t = setTimeout(() => setNoSequencePhase('diving'), 500);
    return () => clearTimeout(t);
  }, [noSequencePhase]);

  useEffect(() => {
    if (noSequencePhase !== 'diving') return;
    const tCollision = setTimeout(() => setCollisionOccurred(true), 1100);
    const tDone = setTimeout(() => {
      setNoSequencePhase('done');
      setCornerImg(reiExpectantBlushies);
    }, 2200);
    return () => {
      clearTimeout(tCollision);
      clearTimeout(tDone);
    };
  }, [noSequencePhase]);

  const showSequenceImg = ['galaxy', 'rotating', 'fade', 'diving'].includes(noSequencePhase);

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm title-chan</span>
        <h1>Project Valen</h1>
        <p>Hey yo Tony, where'd you get that fresh pepperoni?</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q5__center">
      <span className="secretpin__title q2__greeting q10__greeting">{yesChecked ? 'Well, yeah, duh' : "I'm awesome hehe"}</span>
      {!yesChecked && (
        <div className="q2__options q5__options q10__options" onMouseLeave={handleOptionsMouseLeave}>
          <button
            type="button"
            className="dashboard__button dashboard__button--primary home__button"
            onClick={handleYesClick}
            onMouseEnter={handleYesMouseEnter}
          >
            {collisionOccurred ? 'Of course!' : 'Yes'}
          </button>
          <button
            type="button"
            className={`dashboard__button dashboard__button--primary home__button q10__no-btn ${['diving', 'done'].includes(noSequencePhase) ? 'q10__no-btn--knocked' : ''}`}
            onClick={handleNoClick}
            onMouseEnter={handleNoMouseEnter}
          >
            No
          </button>
        </div>
      )}
      {cornerImg && !showSequenceImg && (
        <img
          src={cornerImg}
          alt=""
          className={`q10__corner-img ${cornerImg === reiExpectantBlushies ? 'q10__corner-img--small' : ''}`}
        />
      )}
    </div>
    {showSequenceImg && noSequencePhase === 'fade' && (
      <>
        <img src={hansumGalaxy} alt="" className="q10__sequence-img q10__sequence-img--fade-out" />
        <img src={hansumShootingStar} alt="" className="q10__sequence-img q10__sequence-img--fade-in" />
      </>
    )}
    {showSequenceImg && noSequencePhase !== 'fade' && (
      <img
        key={noSequencePhase}
        src={noSequencePhase === 'diving' ? hansumShootingStar : hansumGalaxy}
        alt=""
        className={`q10__sequence-img q10__sequence-img--${noSequencePhase}`}
      />
    )}
    <img src={hansumShootingStar} alt="" className="q10__preload" aria-hidden="true" />
  </div>
  );
}

export default Q10;
